/**
 * Jobs category tree, mirrored from the backend `/api/jobs/meta`. Kept
 * here as a fallback so the UI can render synchronously even before
 * the meta request lands.
 */
export const JOB_CATEGORIES = {
  business: {
    label: "Business Jobs", emoji: "💼",
    subs: ["accounting","administration","customer-service","engineering","healthcare","hospitality","it","manufacturing","marketing","retail","sales","skilled-trades","transportation"],
  },
  local: {
    label: "Local Services", emoji: "🏡",
    subs: ["babysitting","nanny","elder-care","home-cleaning","gardening","plumbing","electrical","painting","carpentry","appliance-repair","house-sitting","pet-care","moving","errands","driving","shopping","delivery"],
  },
  education: {
    label: "Education", emoji: "🎓",
    subs: ["tutors","teachers","language-instructors","music-teachers","dance-teachers","sports-coaches"],
  },
  events: {
    label: "Events", emoji: "🎉",
    subs: ["wedding-staff","photographers","djs","musicians","decorators","catering-staff","security","event-coordinators"],
  },
  freelance: {
    label: "Freelance", emoji: "💻",
    subs: ["graphic-design","website-design","software-development","ai-services","writing","video-editing","accounting","bookkeeping","consulting"],
  },
  volunteers: {
    label: "Volunteers", emoji: "🤝",
    subs: ["community-service","food-banks","religious-organizations","disaster-relief","youth-programs","senior-assistance"],
  },
};

export const EMPLOYMENT_TYPES = [
  "full-time","part-time","temporary","contract","internship","volunteer","gig",
];

export function labelFor(slug) {
  if (!slug) return "";
  return slug.split("-").map((w) => w[0]?.toUpperCase() + w.slice(1)).join(" ");
}

export function findGroupForSub(sub) {
  for (const [gid, g] of Object.entries(JOB_CATEGORIES)) {
    if (g.subs.includes(sub)) return { id: gid, ...g };
  }
  return null;
}
